
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0 highlight-stroke",attrs:{"d":"M14.9.3L2 5.1m21 2.8L14.8.3M23 20.1V7.9M10.1 25L23 20.2M2 17.4V5.1m0 12.3l8.2 7.6m-.1 0V12.7M2 5.1l8.2 7.6m-.1 0L23 7.9","stroke":"#fff","fill":"none","fill-rule":"evenodd"}})])
          )
        }
      }
    